module.exports = __webpack_public_path__ + "img/pds_guide_screen1.7b33b8fd.svg";